import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
  },
  appBar: {
    top: 'auto',
    bottom: 0,
    paddingRight: '0 !important',
  },
}));
